import { render, staticRenderFns } from "./FilesSidebarChatView.vue?vue&type=template&id=5356b7d8&scoped=true"
import script from "./FilesSidebarChatView.vue?vue&type=script&lang=js"
export * from "./FilesSidebarChatView.vue?vue&type=script&lang=js"
import style0 from "./FilesSidebarChatView.vue?vue&type=style&index=0&id=5356b7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356b7d8",
  null
  
)

export default component.exports